<!-- Defer router activation until app init completes (auth, org, theme).
     Without this gate, on first install the router resolves routes before
     init finishes, causing the catch-all :hash route to match and show
     a "Not Found" error instead of the login page. -->
<ion-app>
  @if (isInitialized()) {
    <ion-router-outlet></ion-router-outlet>
  }
</ion-app>
@if (showSplash()) {
  <div
    class="fixed inset-0 z-9999"
    [class.animate-splash-dissolve]="splashFadingOut()"
  >
    <app-overlay-splash variant="entry" />
  </div>
}
